import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";

export const downloadFileCommentSingle = async ({
  documentName,
  commentID,
  sharepointToken,
}: {
  documentName?: string;
  commentID?: string;
  sharepointToken?: string;
}) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadFileComment,
    JSON.stringify({
      DocumentName: documentName,
      CommentID: commentID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const downloadFileCommentMulti = async ({
  documentName,
  commentID,
  sharepointToken,
}: {
  documentName?: string;
  commentID?: string;
  sharepointToken?: string;
}) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadFileCommentMulti,
    JSON.stringify({
      DocumentName: documentName,
      CommentID: commentID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};
